<template>
  <div class="p-0 col-12 animated fadeIn">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-6">
            <label>Start Date</label>
            <kendo-datepicker class="form-control" v-model="startDate" format="dd-MM-yyyy"></kendo-datepicker>
          </div>
          <div class="col-12 col-md-6">
            <label>End Date</label>
            <kendo-datepicker class="form-control" v-model="endDate" format="dd-MM-yyyy"></kendo-datepicker>
          </div>
        </div>
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" type="button" @click="refreshChart">
          Get Report!
        </button>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div id="geo-chart" style="width: 100%; height: 600px"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      startDate: moment().subtract(parseInt(moment().format('DD')) - 1, 'days').format('DD-MM-YYYY'),
      endDate: moment().format('DD-MM-YYYY'),
      geoData: []
    }
  },
  created () {
    // get report data
    this.getReport()
  },
  methods: {
    refreshChart () {
      this.getReport()
    },
    getReport () {
      var vm = this
      vm.axios.get('api/report/geo/customer/?date=' + encodeURIComponent(moment(vm.startDate, 'DD-MM-YYYY').format('YYYYMMDD') + ';' + moment(vm.endDate, 'DD-MM-YYYY').format('YYYYMMDD')))
        .then(
          (response) => {
            console.log(response)
            vm.geoData = response.data
            vm.initChart()
          }
        )
    },
    initChart () {
      var vm = this
      var data = []
      for (var i = 0; i < vm.geoData.length; i++) {
        var geo = vm.geoData[i]
        var row = {
          'title': geo['city_name'],
          'id': geo['city'],
          'value': geo['popularity']
        }
        data.push(row)
      }

      window.AmCharts.makeChart('geo-chart', {
        'type': 'map',
        'theme': 'light',
        'colorSteps': 20,
        'dataProvider': {
          'map': 'indonesiaHigh',
          'areas': data
        },
        'areasSettings': {
          'autoZoom': true,
          'unlistedAreasAlpha': 0.1,
          'color': '#FFDE03',
          'colorSolid': '#FF0266',
          'balloonText': '<strong>[[title]]</strong><br/>sales value at Rp [[value]]'
        },
        'valueLegend': {
          'right': 10
        }
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/report/GeoReport.vue